module.exports = __webpack_public_path__ + "static/img/activity_sdy_07-4.1d931db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_07-4.jpg
// module id = lFxY
// module chunks = 0